import React, { useEffect, useMemo } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchStateByCountry } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";

const StateDropDown = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
  rowData,
  required,
}) => {
  const selectedState = watch("state_id");

  const { data, isLoading, error } = useQuery(
    ["states"],
    () => fetchStateByCountry("IN"),
    {
      keepPreviousData: false,
      staleTime: DROPDOWN_STALE_TIME,
    }
  );

  const options = useMemo(
    () =>
      data?.data?.map((state) => ({
        value: state.state_id,
        label: state.state,
      })) || [],
    [data]
  );

  useEffect(() => {
    if (rowData && options.length) {
      let selectedOption = options.find(
        (option) => option.value === rowData?.state_id
      );

      if (!selectedOption) {
        selectedOption = options.find(
          (option) => option.label === rowData?.state
        );
      }

      if (selectedOption) {
        setValue("state_id", selectedOption.value);
        setValue("state", selectedOption.label);
      }
    }
  }, [rowData, options, setValue]);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading States</div>;

  return (
    <Controller
      name="state_id"
      control={control}
      rules={{
        required: required ? "State is required" : false,
        validate: (value) => {
          if (required && !value) return "State is required";
          return true;
        },
      }}
      render={({ field }) => {
        const selectedOption = options.find(
          (option) => option.value === selectedState
        );

        return (
          <Select
            {...field}
            options={options}
            isClearable
            placeholder="Select State"
            menuPortalTarget={document.body}
            value={selectedOption || null}
            onChange={(selectedOption) => {
              const value = selectedOption ? selectedOption.value : "";
              const label = selectedOption ? selectedOption.label : "";

              field.onChange(value);
              setValue("state_id", value);
              setValue("state", label);
            }}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            className={`react-select-container ${errors.state_id ? "is-invalid" : ""}`}
          />
        );
      }}
    />
  );
};

export default StateDropDown;
